import type { AssistantTimelineV2 } from './hooks'

/**
 * Merge server (RUN_FINISHED) timeline with client-built streaming timeline.
 *
 * - When the server sends a non-empty normalized timeline, **server wins**
 *   (no supplemental merge of local rows — avoids resurrecting duplicate text).
 * - When the server timeline is empty but the client built rows during streaming:
 *   - If local has any tool rows, keep **local** (must not drop streamed tools).
 *   - If local is **text-only**, prefer **server** (empty) so prose is not duplicated
 *     with `message.content` (simple-question path normalizes away timeline text).
 */
export function mergeAssistantTimelines(
  server: AssistantTimelineV2 | undefined,
  local: AssistantTimelineV2 | undefined,
): AssistantTimelineV2 | undefined {
  const serverOk = server?.schema_version === 2
  const localOk = local?.schema_version === 2

  if (!serverOk && !localOk) return undefined
  if (!serverOk) return local
  if (!localOk) return server

  const sLen = server.entries.length
  const lLen = local.entries.length

  if (sLen === 0 && lLen > 0) {
    const localHasTools = local.entries.some((e) => e.kind === 'tool_call' || e.kind === 'tool_result')
    if (localHasTools) return local
    return server
  }
  if (sLen > 0) return {schema_version: 2, entries: [...server.entries]}
  return local
}
